<template>
  <v-card max-width="426" class="mx-auto pa-6 text-center">
    <div class="text-h5 text--secondary mb-5">
      {{ $t("auth.loginPage.title") }}
    </div>

    <v-form @submit.prevent="onSubmit" ref="login">
      <v-text-field
        v-model="form.username"
        :rules="usernameRules"
        required
        :label="$t('auth.loginPage.loginForm.username')"
        filled
        hide-details="auto"
        class="theme-custom-input mb-5"
        autofocus
      >
      </v-text-field>

      <v-text-field
        v-model="form.password"
        :rules="passwordRules"
        required
        :type="showPassword ? 'text' : 'password'"
        :label="$t('auth.loginPage.loginForm.password')"
        filled
        hide-details="auto"
        class="theme-custom-input mb-5"
      >
        <template v-slot:append>
          <div @click="showPassword = !showPassword" class="cursor-pointer">
            <v-icon size="24" v-if="showPassword">$eyeShow</v-icon>
            <v-icon size="24" v-else>$eyeHidden</v-icon>
          </div>
        </template>
      </v-text-field>

      <v-btn
        color="primary"
        depressed
        :loading="loading"
        block
        class="py-7 mb-5"
        type="submit"
        >{{ $t("auth.loginPage.loginForm.loginButton") }}</v-btn
      >
    </v-form>

    <router-link :to="{ name: 'forgetPassword' }">
      {{ $t("auth.loginPage.forgetPassword") }}
    </router-link>
  </v-card>
</template>

<script>
import { authService } from "@/services";
import Router from "@/router";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "login-form",
  components: {},
  props: [],
  mixins: [],
  data() {
    return {
      loading: false,
      showPassword: false,
      form: {
        username: "",
        password: ""
      },
      errors: [],
      usernameRules: [
        v => !!v || this.$t("auth.loginPage.loginForm.usernameNotEmpty")
      ],
      passwordRules: [
        v => !!v || this.$t("auth.loginPage.loginForm.passwordNotEmpty")
      ]
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo/GET_USERINFO"
    })
  },
  beforeRouteEnter(to, from, next) {
    if (
      localStorage.getItem("access_token") &&
      localStorage.getItem("refresh_token")
    ) {
      Router.replace({ name: "panel" });
    } else {
      next();
    }
  },
  methods: {
    onSubmit() {
      if (!this.$refs.login.validate()) {
        return;
      }
      this.loading = true;
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      authService
        .signIn(this.form)
        .then(response => {
          localStorage.setItem("access_token", response.data.access_token);
          localStorage.setItem("refresh_token", response.data.refresh_token);
          this.login();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async login() {
      await this.userInfoSubmission();
      const userStatus = this.userInfo.userStatus;
      if (userStatus === "UNVERIFIED") {
        this.$router.push({ name: "changePassword" });
      } else if (userStatus === "ACTIVE") {
        this.$router.replace({ name: "panel" });
      }
      // authService.userInfo().then((response) => {
      //   const userStatus = response.data.data.userStatus;
      //   if (userStatus === "UNVERIFIED") {
      //     this.$router.push({ name: "changePassword" });
      //   } else if (userStatus === "ACTIVE") {
      //     this.$router.replace({ name: "panel" });
      //   }
      // });
    },
    ...mapActions({
      userInfoSubmission: "userInfo/ACTION_USERINFO"
    })
  }
};
</script>

<style scoped lang="scss">
@import "LoginForm";
</style>
